module.exports = __webpack_public_path__ + "img/part5.b57b3982.jpeg";